<template>
    <vertical-radio
        :title="$t('otherInvestments.title')">
        <vertical-radio-item
            icon="other-investments-yes"
            :checked="otherInvestments === OtherInvestments.YES"
            @click="onSetOtherInvestments(OtherInvestments.YES)">
            <template slot="title">
                {{ $t('otherInvestments.yes.title') }}
            </template>
            <template slot="body">
                {{ $t('otherInvestments.yes.body.main') }}
                <collapsible
                    :title="$t('otherInvestments.yes.body.example.link')"
                    :show-on-init="collapseVisibility"
                    @update="onCollapseUpdate">
                    <p class="other-investments-radio__help">
                        <span class="other-investments-radio__example-header">{{ $t('otherInvestments.yes.body.example.header') }}</span>
                        {{ $t('otherInvestments.yes.body.example.text') }}
                    </p>
                </collapsible>
            </template>
        </vertical-radio-item>

        <vertical-radio-item
            icon="other-investments-no"
            :checked="otherInvestments === OtherInvestments.NO"
            @click="onSetOtherInvestments(OtherInvestments.NO)">
            <template slot="title">
                {{ $t('otherInvestments.no.title') }}
            </template>
            <template slot="body">
                {{ $t('otherInvestments.no.body.main') }}
                <collapsible
                    :title="$t('otherInvestments.no.body.example.link')"
                    :show-on-init="collapseVisibility"
                    @update="onCollapseUpdate">
                    <p class="other-investments-radio__help">
                        <span class="other-investments-radio__example-header">{{ $t('otherInvestments.no.body.example.header') }}</span>
                        {{ $t('otherInvestments.no.body.example.text') }}
                    </p>
                </collapsible>
            </template>
        </vertical-radio-item>
    </vertical-radio>
</template>

<script>
import { OtherInvestments } from '@/api/enums';
import Collapsible from '@/components/common/Collapsible';
import VerticalRadioItem from '@/components/common/VerticalRadioItem';
import VerticalRadio from '@/components/common/VerticalRadio';

import { mapState, mapActions, mapGetters } from 'vuex';

export default {
    name: 'OtherInvestmentsRadio',
    components: {
        Collapsible,
        VerticalRadioItem,
        VerticalRadio,
    },
    computed: {
        ...mapState(['otherInvestments']),
        ...mapGetters(['isInEditMode']),
    },
    data () {
        return {
            OtherInvestments,
            collapseVisibility: false,
        };
    },
    methods: {
        ...mapActions(['setOtherInvestments']),
        onSetOtherInvestments (investment) {
            this.setOtherInvestments(investment);
        },
        onCollapseUpdate (newValue) {
            this.collapseVisibility = newValue;
        },
    },
    created () {
        if (!this.isInEditMode) {
            this.onSetOtherInvestments(OtherInvestments.YES);
        }
    },
};
</script>

<style scoped lang="scss">
.other-investments-radio {
  &__example-header {
    text-decoration: underline;
  }
}
.other-investments-radio__help {
  font-size: 15px;
  line-height: 25px;
  color: $mb-grey5;
  margin-bottom: 0;

  @include media-breakpoint-down(xs) {
    font-size: 11px;
    line-height: 14px;
  }
}

::v-deep .collapsible {
  .card-body {
    padding-bottom: 0;
  }
  .btn-link {
    @include font-copy();
  }
}
</style>
